const NETWORK_ERROR_SUBSTRINGS = [
  'Load failed',
  'NetworkError',
  'Failed to fetch',
];

// Matches any the above substrings, ignoring case
const NETWORK_ERROR_REGEX = new RegExp(NETWORK_ERROR_SUBSTRINGS.join('|'), 'i');

const UNSUPPORTED_BROWSER_ERROR_SUBSTRINGS = [
  'Intl.Locale',
];

// Matches any the above substrings, ignoring case
const UNSUPPORTED_BROWSER_ERROR_REGEX = new RegExp(UNSUPPORTED_BROWSER_ERROR_SUBSTRINGS.join('|'), 'i');

/**
 * Coaxes a value of `unknown` into an `Error`. For use with try/catch, etc.
 */
export const errorOf = (error: unknown) =>
  error instanceof Error
    ? error
    : new Error(
      typeof error === 'string'
        ? error
        : 'Unknown error'
    );

/**
 * Returns `true` if the error is due to a client network error that we have no control over.
 */
export const isNetworkError = (error: Error) => NETWORK_ERROR_REGEX.test(error.message);

/**
 * Returns `true` if the error is due to the client using an unsupported browser.
 */
export const isUnsupportedBrowserError = (error: Error) => UNSUPPORTED_BROWSER_ERROR_REGEX.test(error.message);
